import React, { Component } from 'react'
// components:
import { Slider } from '@mui/material';
import {Row , Col} from 'react-bootstrap'
import Modal from 'react-bootstrap/Modal'
import houseSvg from '../assets/image/houseSvg.svg'
import appartmentSvg from '../assets/image/appartement.svg'
import smallFace from '../assets/image_icon_Screen/smallFace.svg'
import mediumFace from '../assets/image_icon_Screen/mediumFace.svg'
import bigFace from '../assets/image_icon_Screen/bigFace.svg'
import verybigFace from '../assets/image_icon_Screen/verybigFace.svg'
import questionsvg from '../assets/image/question.svg'
import btnarrowsvg from '../assets/image/arrow-white.svg'
import SouthFace from '../assets/image_icon_Screen/SouthFace.svg'
import SouthEastFace from '../assets/image_icon_Screen/SouthEastFace.svg'
import WestEastFace from '../assets/image_icon_Screen/WestEastFace.svg'
import DontKnowFace from '../assets/image_icon_Screen/DontKnowFace.svg'
import FlatRoof from '../assets/image_icon_Screen/FlatRoof.svg'
import NorthFace from '../assets/image_icon_Screen/NorthFace.svg'


// consts

import { Button   } from 'react-bootstrap';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import  '../App.css'
import './indexAutoSome.scss'
import AutoCompleteMain from './AutoCompleteMain';
import { Stepper, Step, StepLabel, Typography, Paper } from '@mui/material';
import styled from 'styled-components';


const formatValue = (value, decimalPlaces) => {
  return value !== undefined ? value.toFixed(decimalPlaces) : '';
};





class Autocomplete extends Component {
  constructor(props) {
    super(props);
    this.state = {
      defaultMarker:null,
      mapInstance: null,
      thirdStepCopy:false,
      shadowSteps:0,
      colorCodeRgb:'219,56,50',  ///set Color for the UI theme
      secondLoader:false,
      maxRoof : null,
      fifthStepShadow:false, //Need to add trigger for 5th step
      isValidPostal:false,  ///Need to add trigger for postal codes validation
      oneColumnTrigger:false, /// Trigger for one/ two column change
      isManual:false,
      atleastOneSelected:false,
      activeButtonRow1: null,
      orientationManual:0,
      inclinaisonManual:0,
      areaMeters2Manual:0,
      activeButtonRow2: null,
      fourthStepShadow:false,  
      places: [],
      drawingMarkerEnabled:null,
      showModal:false,
      solarPotential: props.solarPotential || null,
      solarPotential1: props.solarPotential || null,
      selectedRoof: null,
      selectedRoof1: null,
      buttonVariant: 'outline-danger',
      mapRef: React.createRef(),
      accumulatedValues: [],
      obstacleAccumulatedValues: [],
      windowHeight: window.innerHeight - 80,
      // accumulatedValues1: [],
      accumulatedValues1: [0, 0],
      faceProductions: [],
      loading: false,
      latlong:[],
      panelCount: 0,
      panelPower: 0,
      pannelSurface: 0,
      copypanelCount: 0,
      placeSelected:false,
      address: '',
      manualProductible: 0,
      // Initial value of address
      // accumulatedValues1: [0, 0, 0],
      OrientationChange: '',
      InclinaisonChang: '',
      step: 0,
      hideMap: true,
      nameLead: '',
      map:undefined,
      surnameLead: '',
      isOwner: 'Maison',
      isFormSubmit: false,
      setIsChecked: '',
      faceNumber: '',
      faceProductible: '',
      faceSurface: '',
      latLong:[],
      faceOrientation: '',
      faceInclinaison: '',
      monthlyInvoice: 250,
      email: '',
      phone: '',
      address1: '',
      projectTiming: '',
      isFirstLine:false,
      emailError:'',
      isSecondLine:false,
      totalSteps:[0,1,2,3],
      isThirdLine:false,
      isChecked: false,
      isChecked1: false,
      yourSituation:'Actif',
      typeOfAC:'Sans climatisation',
      domesticHeating:'Chauffe-eau électrique',
      typeOfHeating:"Chauffage au gaz, fioul ou bois",
      hasPool:'Pas de piscine',
      valueLow: false,
      idHash: null,
      // drawingMarkerEnabled: false,
      postalCode: '',
      city: '',
      recommendedSimulation: null,
      minimumSimulation: null,
      marks:
        [
          {
            value: 100,
          },   {
            value:40,
            label: '40€'
          },  {
            value: 500,
            label: '500€'
          }],
          labelArray:[`
Réduisez votre facture d'électricité jusqu'à 50%.
Estimez vos économies en 4 étapes seulement !`,
          "Cliquez sur le toit de votre maison", 
`Votre maison est éligible !
Voici le pan solaire optimum de votre toiture` ,[
`Nous n’avons pas pu analyser votre toiture !
Donnez-nous ses caractéristiques :`
          ]

        ],
        listOfLoadingPoints:[
          [
            "Analyse de votre toiture",
            "Identification du meilleur pan",
            "Calcul du productible solaire "

          ],
          [
            "Calcul du rendement optimum",
            "Calcul du meilleur prix",
            "Calcul de vos économies"
          ]
        ],
        heightOfReactangle:[
          4,8,10,20
        ],
        widthOfReactangle:[
          4,4.5,5,15
        ],
        orientationSelection:[
          0,45,90,175,0,30
        ],
        inclinaisonSelection:[
          20,20,20,20,0,20
        ],
        theme: createTheme({

        }),
        sliderTheme: createTheme({
         
        })
        }   
  }
 
  

  setMonthlyInvoice = async (e) => {
    const monthlyInvoice = parseInt(e.target.value, 10); // Convert value to an integer

    // Check if monthlyInvoice is below 100
    const valueLow = monthlyInvoice < 100;
  
    // Update the state
    this.setState({
      monthlyInvoice: monthlyInvoice,
      valueLow: valueLow
    });
  
  }

  validateEmail = (email) => {
    // Regular expression for validating email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/    ;
    return emailRegex.test(email);
  };

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  
    // Validate email syntax
    if (name === 'email') {
      const isValidEmail = this.validateEmail(value);
      this.setState({ emailError: isValidEmail ? '' : 'Please enter a valid email address' });
    }

  };

  handleClose = () => this.setState({ showModal: false });

  loadslardata = async (isFastForwad) => {

    this.setState({ loading: true });
    setTimeout(() => {
      this.setState({isFirstLine:true})
    }, 0);

    setTimeout(() => {
      this.setState({isSecondLine:true})
    }, 400);
    setTimeout(() => {
      this.setState({isThirdLine:true})
    }, 1600);
    const apiKey = '&key=AIzaSyCXaNiqQCxsTyb-t4IzQ3-NziyVyViwMbY';
    let quality = 'HIGH'
    let response = await fetch('https://solar.googleapis.com/v1/buildingInsights:findClosest?location.latitude=' + this.state.latlong.lat+ '&location.longitude=' + this.state.latlong.lng + '&requiredQuality='+ quality + apiKey);

    if (response.status === 404) {
      quality = 'MEDIUM'
      response = await fetch('https://solar.googleapis.com/v1/buildingInsights:findClosest?location.latitude=' + this.state.latlong.lat + '&location.longitude=' + this.state.latlong.lng + '&requiredQuality=' + quality + apiKey);
    }
    // const response2 = await fetch('https://solar.googleapis.com/v1/dataLayers:get?location.latitude=' + this.state.latlong.lat + '&location.longitude=' + this.state.latlong.lng + '&radiusMeters=50&view=FULL_LAYERS&requiredQuality=HIGH&pixelSizeMeters=0.1' + apiKey);


    try {
      setTimeout(() => {
        this.setState({ loading: false });
        this.setState({
          isFirstLine: false,
          isSecondLine: false,
          isThirdLine: false
        })

      }, 1000);

      // Start analysing the JSON in order to add the production per kWp on each face

      // const response3 = await fetch(tiffUrl  );
      // const tiffData = await response.blob();
      // // Process the GeoTIFF data here



      if (!response.ok) {
        throw new Error('Network response for buildingInsights was not ok');
      }



      if (response.ok) {
        const obj = await response.json();
        var obj1 = obj["solarPotential"];
        var panelCapacity = obj1["panelCapacityWatts"];
        // Power of 250 Wp per pannel by default in Google Solar today. Maybe it will be possible to adjust pannel power soon !
        var obj2 = obj1["roofSegmentStats"];
        var nbrOfFaces = obj2.length; // Determine the number of faces on the house
        var obj3 = obj1["solarPanelConfigs"];
        var nbrOfConfigurations = obj3.length; // Determine all the combinaisons possibles of configuration with the faces on the roof.
        var obj4 = obj3[nbrOfConfigurations - 1]; // we use the last configuration to get the information we calculate the irradiation on each face
        var obj5 = obj4["roofSegmentSummaries"];

        var loss = 0.14; // 14% system loss that needs to be used for evaluate the production on each face (and that Google don't take into account !)

        // For each face, we will add the production information : kWh per kWp
        for (var key in obj5) {
          var nbrPanel = obj5[key].panelsCount;
          var yearEnergy = obj5[key].yearlyEnergyDcKwh;
          var faceProduction = yearEnergy / nbrPanel / panelCapacity * 1000 * (1 - loss);


          // Add to the roofSegmentStats object the "FaceProduction" and Max number of panel (calculated by Google on its pannel size) data which was missing to calculate the production !
          obj2[key].productible = faceProduction;
          obj2[key].maxNbrPannels = nbrPanel;
          // Example of calculation for a solar kit with 8 pannels with pannel capacity of 400 Wp
          // solar kit power is : 8 pannels X 400 Wp / 1000 = 3.2 kWp
        }

        // ADDITIONAL CODE //
        this.sortAndFindOrder(obj2);

        // KRUNAL : this function will reorder the faces according to their power and orientation.
        // You need to display the face's pointer with the number you have in the object = > obj2[index].faceNumber


        // Prepare the Json we will send to the back with only the right information



        const result = obj;
        const roofsegemnts = result.solarPotential.roofSegmentStats;
        var obj1 = result["solarPotential"];
        var panelCapacity = obj1["panelCapacityWatts"];
        var obj2 = obj1["roofSegmentStats"];
        // var nbrOfFaces = obj2.length; // Determine the number of faces on the house
        var obj3 = obj1["solarPanelConfigs"];
        var nbrOfConfigurations = obj3.length; // Determine all the combinaisons possibles of configuration with the faces on the roof.
        var obj4 = obj3[nbrOfConfigurations - 1]; // we use the last configuration to get the information we calculate the irradiation on each face
        var obj5 = obj4["roofSegmentSummaries"];
        var loss = 0.14;
        const production = []
        for (var key in obj5) {
          var nbrPanel = obj5[key].panelsCount;
          var yearEnergy = obj5[key].yearlyEnergyDcKwh;
          var faceProduction = yearEnergy / nbrPanel / panelCapacity * 1000 * (1 - loss);
          obj2[key].productible = faceProduction;
          production.push(formatValue(faceProduction, 2))
        }
        const roofs = [];
        // const max = production.reduce((maxObj, current, index) => {
        //   const currentProduction = current * roofsegemnts[index].stats.areaMeters2;
        //   if ((maxObj.accumulator * roofsegemnts[maxObj.index].stats.areaMeters2) > currentProduction) {
        //     return maxObj;
        //   }
        //   return { accumulator: current, index: index };
        // }, {
        //   accumulator: 0,
        //   index: 0
        // });
        for (let i = 0; i < roofsegemnts.length; i++) {
          const segment = roofsegemnts[i];
          segment["name"] = 'Pan ' + (i + 1);
          segment["solarproduction"] = production[i];
          roofs.push(segment);
        };
        this.setState({ solarPotential: roofs });
      }
    }
    catch(error){
      this.setState({
        isManual:true,
        shadowSteps:3,
        isManual:true,
        step:2,
      })
    }
  }

  setSolarPotential = (solarPotentials) => {
    this.setState({ solarPotential: solarPotentials });
  };

  sortAndFindOrder(obj) {
    if(this.state.defaultMarker) this.state.defaultMarker.setMap(null)
    const powers = []; // Initial array of powers
  
    // Iterating over each property in the object
    Object.keys(obj).forEach((key) => {
      if (obj.hasOwnProperty(key)) {
        // Calculate the power for each item and push it into the powers array
        let power = obj[key].productible * obj[key].stats.areaMeters2;
  
        // Put negative power for the face oriented in north direction to deprioritize them
        if (obj[key].azimuthDegrees < 90 || obj[key].azimuthDegrees > 270) {
          power = -power;
        }
        powers.push(power);
      }
    });
  
    // Create an array of objects with each power and its original index
    const powersWithIndex = powers.map((value, index) => ({ value, index ,center:obj[index].center,obj:obj[index] }));
    
    // Sort the array of objects by power values, considering special ordering for negative values
    powersWithIndex.sort((a, b) => {
      if (a.value < 0 && b.value < 0) {
        // Both values are negative, sort in ascending order to have descending effect for negative values
        return a.value - b.value;
      } else {
        // Default sort in descending order for positive values
        return b.value - a.value;
      }
    });
  
    // Create an array with the original order of the sorted powers
    // KRUNAL : you can use this table to know the new face's number for pointer
    const sortedFaces = powersWithIndex.map(obj => obj.index);
    // Previously, the number 1 face was the face with index 0, now you can find its index with sortedFaces[0]

    // Update the original object with the face numbers based on new order
    // powersWithIndex.forEach((item, index) => {
    //   if (obj.hasOwnProperty(index)) {
    //     // Update each item in the object with its new face number based on sorting
    //     obj[index].faceNumber = item.index;
    //   }
    // });

    for (const key in sortedFaces) {
      if (sortedFaces.hasOwnProperty(key)) {
        // Add into each face object the right « faceNumber »
        obj[sortedFaces[key]].faceNumber = Number(key) + 1;
      }
    }

    const solarproduction = powersWithIndex[0].value;
    powersWithIndex[0].obj.solarproduction = solarproduction;
    this.setState({
      maxRoof: powersWithIndex[0].obj,
      shadowSteps:2,
    })
    const loc = { lat: powersWithIndex[0].center.latitude, lng: powersWithIndex[0].center.longitude };
    const marker = new window.google.maps.Marker({
      position: loc,
      title: powersWithIndex[0].obj.name,
      label: '',
    });
    // this.setState({maxRoof:segment})
    marker.addListener('click', () => {
      this.setState({ selectedRoof: powersWithIndex[0] });
    });
    marker.setLabel(null)
    marker.setMap(this.state.map)
  };

  updateSimulationTracking = (lastStep) => {
    const baseUrl = process.env.REACT_APP_BACK_BASE_URL
    const path = '/simulation/updateTracking'

    const fullUrl = baseUrl + path    

    fetch(fullUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        idHash: this.state.idHash,
        lastStep: lastStep
      }),
    })
  }

  handleRadioChange = (value) => {
    this.setState({isOwner: value});
  };
  handleCheckboxChange = async(e) => {
    await this.setState({ isChecked: (e.target.checked) });
    this.setState({atleastOneSelected:this.handleDoubleCheck()})
    
  }

  handleCheckboxChange1 = async(e) => {
    await this.setState({ isChecked1: e.target.checked });
    this.setState({atleastOneSelected:this.handleDoubleCheck()})
  };
  handleDoubleCheck = () =>{
    if(!this.state.isChecked){
      return false
    }
  };



  componentDidMount = () => {
    const baseUrl = process.env.REACT_APP_BACK_BASE_URL
    const path = '/simulation/createTracking'

    const fullUrl = baseUrl + path

    const root = document.documentElement
    root.style.setProperty('--bs-danger-rgb', this.state.colorCodeRgb)
    this.setState({
      colorCodeRgb: `rgb(${this.state.colorCodeRgb})`
    })
    // root.style.setProperty('--bs-danger', '#d10000')
    setTimeout(() => {
      this.setState({theme:createTheme({
        palette: {
          primary: {
            main: this.state.colorCodeRgb, // Change this to your desired primary color
          },
          secondary: {
            main: '#f50057', // Change this to your desired secondary color
          },
        },
      })})
      this.setState({
        sliderTheme: createTheme({
          components: {
            MuiSlider: {
              styleOverrides: {
                rail: {
                  backgroundColor: this.state.colorCodeRgb, // Track color
                },
                thumb: {
                  backgroundColor: this.state.colorCodeRgb, // Thumb color
                },
                track:{
                  backgroundColor: this.state.colorCodeRgb, 
                  borderColor:this.state.colorCodeRgb// Track color
                },mark:{
                  color:this.state.colorCodeRgb
                },
                valueLabel:{
                  backgroundColor: this.state.colorCodeRgb,
                  fontSize:'18px'
                }
              },
            },
          },
        })
      })
    }, 0);


    const searchParams = new URLSearchParams(window.location.search)
    

    fetch(fullUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        companyId: process.env.REACT_APP_COMPANY_ID,

        utmCampaign: searchParams.get('utm_campaign'),
        utmContent: searchParams.get('utm_content'),
        utmMedium: searchParams.get('utm_medium'),
        utmSource: searchParams.get('utm_source'),
        utmTerm: searchParams.get('utm_term')
      }),
    }).then(response => {
      return response.json();
    })
    .then(data => {
      this.setState({
        idHash: data.idHash
      });
    })
    // window.addEventListener('resize', this.handleResize);
    // const script = document.createElement('script');
    // script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyA_Ql5Bfqu0sKMbv5-PtCHSN4klSBactxQ&libraries=places,geometry,drawing`;
    // script.async = true;
    // document.body.appendChild(script);


    //   // Initialize the Places Autocomplete service
    //   const autocompleteService = new window.google.maps.places.AutocompleteService();

      // Example: Fetch autocomplete predictions for "New York"
  
  }

  //  handleInputChange = (event) => {
  //   const inputText = event.target.value;
  //   if (inputText.trim() !== '') {
  //     // Call the Google Places Autocomplete service
  //     const autocompleteService = new window.google.maps.places.AutocompleteService();
  //     autocompleteService.getPlacePredictions({ input: inputText }, (results, status) => {
  //       if (status === 'OK') {
  //         // Update predictions state with the results
  //         this.setPredictions(results);
  //       } else {
  //         console.error('Autocomplete service failed', status);
  //       }
  //     });
  //   } else {
  //     // Clear predictions if the input is empty
  //     setPredictions([]);
  //   }
  // };


  componentWillUnmount = () => {
    window.removeEventListener('resize', this.handleResize);
  }

  handleChildData = (data) => {
    this.setState({placeSelected:data.placeSelected, address: data.address,isValidPostal:data.isValidPostal, city: data.city})
    if(data.latLong){
      this.setState({
        latLong:data.latLong
      })
    }
    this.setState({ postalCode: data.postalCode });
  }

  handleResize = () => {
    this.setState({
      windowHeight: window.innerHeight - 80,
    });
  };


  render() {
   const {
      isChecked,isChecked1,nameLead, email, phone,projectTiming, step,recommendedSimulation, minimumSimulation  } = this.state;

      const isFormInvalid =
      !this.state.isChecked|| this.state.emailError ||
      phone.length !== 10 ||
      !email.length > 0 ||
      !this.state.surnameLead.length > 0 ||
      !nameLead.length > 0;


    const handleButtonClick = (buttonName,buttonIndex) => {
      this.setState({
        activeButtonRow1:buttonName,
        areaMeters2Manual:this.state.heightOfReactangle[buttonIndex] * this.state.widthOfReactangle[buttonIndex]
      })
    }

    const handleButtonClick2 = (buttonName,buttonIndex) => {
      this.setState({
        activeButtonRow2:buttonName,
        orientationManual:this.state.orientationSelection[buttonIndex],
        inclinaisonManual:this.state.inclinaisonSelection[buttonIndex]
        
      })
    }
    const handleNext = (stepId) => {
      this.updateSimulationTracking(`step-${stepId}`)
      this.setState((prevState) => {

        if (this.state.shadowSteps === 0) {
          const myLatLng = { lat: this.state.latLong[0], lng: this.state.latLong[1] };
          this.setState({ latlong: myLatLng, step: 1 });
          const map = new window.google.maps.Map(document.getElementById("map"), {
            zoom: 20,
            mapTypeId: 'satellite',
            center: myLatLng,
            tilt: 0,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: false,
            mapTypeControl: false,
          });

          var yellowPin = {
            url: 'http://maps.google.com/mapfiles/ms/icons/yellow-dot.png', // You can use your own image URL for the yellow pin
            scaledSize: new window.google.maps.Size(48, 48),  // Adjust the size as needed
            origin: new window.google.maps.Point(0, 0),
            anchor: new window.google.maps.Point(24, 48) // Adjust the anchor point if necessary
          }
          const marker = new window.google.maps.Marker({
            position: myLatLng,
            map,
            title: "Hello World!",
            icon: yellowPin
          });

          this.setState({ hideMap: false });
          this.setState({ defaultMarker: marker });
          this.setState({ map: map ,shadowSteps:1 });
          setTimeout(() => {
            drawingManager()
          }, 0);

          // Ensure to set the map for drawingManager
        }
        if (this.state.shadowSteps === 1) {
          {
            this.loadslardata();
            this.setState({ step: 2 });
          }
        }
        
        if (prevState.step === 2 && this.state.isManual) {
          let monthlyInvoice = this.state.monthlyInvoice;
          let zipCode = this.state.postalCode;
          let companyId = process.env.REACT_APP_COMPANY_ID;

          let faceProductible = 0
          let faceSurface = this.state.areaMeters2Manual
          let roofSectionType = this.state.activeButtonRow2 == 'flatRoof' ? 'flat_roof' : 'tilted_roof'
          let faceInclinaison = this.state.inclinaisonManual
          let faceOrientation = this.state.orientationManual

          const baseUrl = process.env.REACT_APP_BACK_BASE_URL
          const path = '/calculation/getProductible'

          const fullUrl = baseUrl + path

          fetch(fullUrl, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              monthlyBilling: monthlyInvoice,
              roofSectionSurface: faceSurface,
              roofSectionType: roofSectionType,
              roofSectionShadowCoef: 0,
              roofSectionProductible: faceProductible,
              roofSectionOrientation: faceOrientation,
              roofSectionTilt: faceInclinaison,
              zipCode: zipCode,
              companyId: companyId,
            }),
          })
            .then(response => {
              if (!response.ok) {
                throw new Error('Network response was not ok');
              }
              return response.json();
            })
            .then(data => {
              this.setState({
                manualProductible: data
              });
            })
            .catch(error => {
              console.error('Error:', error);
            });
        }


        if (prevState.step === 2 && this.state.shadowSteps === 4 && !this.state.fifthStepShadow) {
          calculateTableData()
        }
        if(this.state.shadowSteps === 5 && prevState.step === 2){
          calculateTableData()
        }
        if (this.state.shadowSteps == 2 && this.state.maxRoof) {
          this.setState({ shadowSteps: 3 })
        }
        if (prevState.step === 2 && this.state.isManual ) {
          this.setState({ hideMap: true ,shadowSteps:4 })
          
        }
        if(prevState.step === 2 && this.state.shadowSteps === 4 && this.state.fifthStepShadow){
          this.setState({ shadowSteps: 5 })
          
        }
        if (prevState.step === 3) {
          this.setState({ step: 4 })
          setTimeout(() => {
            document.getElementById('form-div').scrollTo(0,0)
          }, 0);
        }
        return { step: step };
      });
    };

    const calculateTableData = () =>{
      this.setState({ secondLoader: true })
      let monthlyInvoice = this.state.monthlyInvoice;
      
      let faceSurface
      let faceProductible
      let roofSectionType
      let faceInclinaison
      let faceOrientation

      if (this.state.maxRoof != null) {
        faceSurface = this.state.maxRoof.stats.areaMeters2;
        faceProductible = this.state.maxRoof.productible;
        roofSectionType = this.state.maxRoof.type ? this.state.maxRoof.type : 'tilted_roof'
        faceInclinaison = this.state.maxRoof.pitchDegrees;
        faceOrientation = this.state.maxRoof.azimuthDegrees;
      } else {
        faceSurface = this.state.areaMeters2Manual;
        faceProductible = 0;
        roofSectionType = this.state.inclinaisonManual === 0 ? 'flat_roof' : 'tilted_roof'
        faceInclinaison = this.state.inclinaisonManual;
        faceOrientation = this.state.orientationManual;
      }

      let zipCode = this.state.postalCode;
      let companyId = process.env.REACT_APP_COMPANY_ID;

      const baseUrl = process.env.REACT_APP_BACK_BASE_URL
      const path = '/calculation/getSimulation'

      const fullUrl = baseUrl + path

      fetch(fullUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          monthlyBilling: monthlyInvoice,
          roofSectionSurface: faceSurface,
          roofSectionType: roofSectionType,
          roofSectionShadowCoef: 0,
          roofSectionProductible: faceProductible,
          roofSectionOrientation: faceOrientation,
          roofSectionTilt: faceInclinaison,
          zipCode: zipCode,
          companyId: companyId,
        }),
      })
        .then(response => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.json();
        })
        .then(data => {
          this.setState({
            minimumSimulation: data[0],
            recommendedSimulation: data[1],
            secondLoader: false,
            isFirstLine: false,
            isSecondLine: false,
            isThirdLine: false
          });
        })
        .catch(error => {

          console.error('Error:', error);
          setTimeout(() => {
            this.setState({ secondLoader: false, isFirstLine: false, isSecondLine: false, isThirdLine: false })
          }, 2000);
    
         
        });

      setTimeout(() => {
        this.setState({ isThirdLine: true })
      }, 1600);
      setTimeout(() => {
        this.setState({ isSecondLine: true })
      }, 800);
      setTimeout(() => {
        this.setState({ isFirstLine: true })
      }, 0);
      this.setState({
        step: 3
      })
    }

    const drawingManager = () =>{
      const drawingManager = new window.google.maps.drawing.DrawingManager({
        drawingMode: window.google.maps.drawing.OverlayType.MARKER,
        drawingControl: false,
        polygonOptions: {
          editable: false,
        },
      });

      if(!this.state.drawingMarkerEnabled){ 
        this.setState({drawingMarkerEnabled:drawingManager})
      }
    
      drawingManager.addListener('markercomplete', (e) => {
        e.setMap(null);
        if(step==2){
        drawingManager.setMap(null);}
    
        // Assuming map is defined elsewhere in your code
        this.state.map.setCenter(e.position);
        this.state.map.setZoom(20);
    
        if (this.state.defaultMarker) {
          this.state.defaultMarker.setMap(null);
          var yellowPin = {
            url: 'http://maps.google.com/mapfiles/ms/icons/yellow-dot.png', // You can use your own image URL for the yellow pin
            scaledSize: new window.google.maps.Size(48, 48),  // Adjust the size as needed
            origin: new window.google.maps.Point(0, 0),
            anchor: new window.google.maps.Point(24, 48) // Adjust the anchor point if necessary
          }
          let mark = new window.google.maps.Marker({
                  position: e.position,
                  map: this.state.map,
                  name: 'locationmarker',
                  title: 'location',
                  icon:yellowPin,
                  draggable: false,
                });
                this.setState({defaultMarker:mark,
                  latlong:{
                    lat:e.position.lat(),
                    lng:e.position.lng()
                  }
                })


         
        }

        

     
    
        // Get the address of the location
        // let geocoder = new window.google.maps.Geocoder();
        // let marker = new window.google.maps.Marker({
        //   position: e.position,
        //   map: this.state.map,
        //   name: 'locationmarker',
        //   title: 'location',
        //   draggable: false,
        // });
    
        // // Add dragend event listener to the marker
        // marker.addListener('dragend', () => {
        //   // Your dragend event handler code here
        // });
      });
    
      drawingManager.setMap(this.state.map);
    }

    const handleModal = () =>{

      this.setState({showModal:true})

    }

    const handleFastForward = () =>{
      this.updateSimulationTracking('step-1bis')
      this.setState({
        shadowSteps:3,
        isManual:true,
        step:2
      })
      // this.loadslardata(true)
      
    }

    const handleFastForwardSecond =() =>{
      this.updateSimulationTracking('step-1bis')
      this.setState({
        shadowSteps:3,
        isManual:true,
      })
    }

    const handleFormSubmit = async () =>{
      this.setState({ isFormSubmit: true })
      const searchParams = new URLSearchParams(window.location.search)

      const { recommendedSimulation, isChecked1 } = this.state

      let faceSurface
      let faceInclinaison
      let faceOrientation
  
      if (this.state.maxRoof != null) {
        faceSurface = this.state.maxRoof.stats.areaMeters2;
        faceInclinaison = this.state.maxRoof.pitchDegrees;
        faceOrientation = this.state.maxRoof.azimuthDegrees;
      } else {
        faceSurface = this.state.areaMeters2Manual;
        faceInclinaison = this.state.inclinaisonManual;
        faceOrientation = this.state.orientationManual;
      }

      const pushSimulationDto = {
        idSimulatorTrackingHash: this.state.idHash,
        client: {
          lastName: this.state.nameLead,
          firstName: this.state.surnameLead,
          phone: this.state.phone,
          zipCode: this.state.postalCode,
          email: this.state.email,
          address: this.state.address,
          city: this.state.city
        },

        house: {
          ownerStatus: this.state.isOwner, 
          annualBilling: this.state.monthlyInvoice * 12,
          roof: {
            surface: faceSurface,
            orientation: faceOrientation,
            tilt: faceInclinaison
          }        
        },

        simulation: {
          recommandedPower: recommendedSimulation.recommandedPower,
          panelNumber: recommendedSimulation.recommandedNbrPannels,
          kitId: recommendedSimulation.kitId,
          savingsPercent: recommendedSimulation.savingsPercent,
          savings: recommendedSimulation.savingsFirstYear,
          annualProduction: recommendedSimulation.annualProduction,
          financialAid: recommendedSimulation.subsidy,
          price: recommendedSimulation.price,
          taxesRate: recommendedSimulation.taxesRate
        },
      
        marketingAgreement: this.state.isChecked1 ? "D'accord" : '',
      
        projectTiming: this.state.projectTiming,
        leadDemand: 'rappel',
      
        utmCampaign: searchParams.get('utm_campaign'),
        utmContent: searchParams.get('utm_content'),
        utmMedium: searchParams.get('utm_medium'),
        utmSource: searchParams.get('utm_source'),
        utmTerm: searchParams.get('utm_term')
      }
      const baseUrl = process.env.REACT_APP_BACK_BASE_URL
      const path = '/simulation/push'

      const fullUrl = baseUrl + path

      await fetch(fullUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(pushSimulationDto) 
      }).finally(v => this.setState({ isFormSubmit: false }))

      window.top.location.href = 'https://www.goom.digital/lp/conforama/merci.html'
    }



    const handleNextKO = () =>{
      this.updateSimulationTracking('step-2')
      this.setState({
        shadowSteps:4,
        step:2
      })
    }



    return (
      <div className='container'>
         <div className='main-wrapper-component' tabIndex={1} id='form-div'>

        {this.state.loading &&
          <div className=' d-flex justify-content-center align-items-center flex-column h-100 my-auto w-100 mx-auto p-5'>
            {/* <div><img src={require("../assets/image/loadingCrop.gif")} /> </div> */}
             <div><div class="custom-loader"></div></div>
           
            <div className='text-wrapper '>
              <ul class="arrow-list d-flex align-items-start justify-content-center flex-column">
                {
                  this.state.isFirstLine && (<>
                                 <div className='d-flex align-items-center justify-content-between'><span className='mx-2 arrow-list-arrow span-diff'>1.</span>
                    {/* <p className='arrow-list-arrow my-1 mx-2'> &#x2192;</p> */}
                    <li>{this.state.listOfLoadingPoints[0][0]}</li></div>
                  </>)
                }
                                {
                  this.state.isSecondLine && (<>
                                 <div className='d-flex align-items-center justify-content-between'><span className='mx-2 arrow-list-arrow span-diff'>2.</span>
                    {/* <p className='arrow-list-arrow my-1 mx-2'> &#x2192;</p> */}
                    <li>{this.state.listOfLoadingPoints[0][1]}</li></div>
                  </>)
                }
                                {
                  this.state.isThirdLine && (<>
                                 <div className='d-flex align-items-center justify-content-between'><span className='mx-2 arrow-list-arrow span-diff'>3.</span>
                     {/* <p className='arrow-list-arrow my-1 mx-2'> &#x2192;</p> */}
                    <li>{this.state.listOfLoadingPoints[0][2]}</li></div>
                  </>)
                }
              </ul>
            </div>
          </div>
        }
        {this.state.secondLoader &&
          <div className='d-flex justify-content-center align-items-center flex-column p-5'>
            {/* <div><img src={require("../assets/image/loadingCrop.gif")} /></div> */}
            <div><div class="custom-loader"></div></div>
            <div className='text-wrapper mt-2'>
              <ul class="arrow-list d-flex align-items-start justify-content-center flex-column">
              {
                  this.state.isFirstLine && (<>
                                 <div className='d-flex align-items-center justify-content-between'><span className='mx-2 arrow-list-arrow span-diff'>1.</span>
                   {/* <p className='arrow-list-arrow my-1 mx-2'> &#x2192;</p>  */}
                    <li>{this.state.listOfLoadingPoints[1][0]}</li></div>
                  </>)
                }
                                {
                  this.state.isSecondLine && (<>
                                 <div className='d-flex align-items-center justify-content-between'><span className='mx-2 arrow-list-arrow span-diff'>2.</span>
                    {/* <p className='arrow-list-arrow my-1 mx-2'> &#x2192;</p> */}
                    <li>{this.state.listOfLoadingPoints[1][1]}</li></div>
                  </>)
                }
                                {
                  this.state.isThirdLine && (<>
                                 <div className='d-flex align-items-center justify-content-between'><span className='mx-2 arrow-list-arrow span-diff'>3.</span>
                    {/* <p className='arrow-list-arrow my-1 mx-2'> &#x2192;</p> */}
                    <li>{this.state.listOfLoadingPoints[1][2]}</li></div>
                  </>)
                }
              </ul>
            </div>
          </div>
        }
        <div style={{  }} className='mx-auto ' hidden={this.state.loading || this.state.secondLoader}>
          <div className='stepper-class' hidden={this.state.step >= 4}>
            <ThemeProvider theme={this.state.theme} >
            <div className="stepper">
      {this.state.totalSteps.map(step => (
        <div
          key={step}
          className={`stepper-step ${this.state.step === step ? 'active' : ''}`}
     
        >
          <div className="stepper-label"> {step + 1}</div>
        </div>
      ))}
    </div>
            </ThemeProvider>
          </div>
          <div className='text-center mx-auto mt-4' >
            <label className='big-title' style={{ display: `${(this.state.shadowSteps === 3  || this.state.shadowSteps === 4 || this.state.shadowSteps === 5 ? 'none' : 'block')}` }}>{this.state.labelArray[step]}</label>
          </div>
          <div className={`bd-highlight ${ this.state.shadowSteps === 3 || this.state.shadowSteps === 4 || this.state.shadowSteps === 5 ? '' : 'd-flex'}`} style={{ height: `${(this.state.step > 0 ? '60vh' : 'auto')}`, display: `${( this.state.shadowSteps === 3 || this.state.shadowSteps === 4  || this.state.shadowSteps === 5 ? 'none' : 'flex')}` }}>

            <div id="map" className='map-secstep' style={{ }} hidden={this.state.hideMap}></div>



            <div class="architectural-proximity-container w-100 p-2" style={{}} hidden={!this.state.hideMap || step === 2}>


              {step === 0 && (

                <div>


                  <label className="label-class">De quel type de logement je suis propriétaire ?</label>
                  <div style={{ marginBottom: '20px' }}>
                    <Row style={{ display: 'flex', justifyContent: 'space-between', color: 'black', flexWrap: 'wrap' }}>
                <div  className='buildings-button-wrapper'>
                      <Button
                        type='radio'
                        name="btnradio"
                        id="btnradio1"
                        autoComplete="off"
                        active={this.state.isOwner === 'Maison'}
                        value={'Maison'}
                        variant=""
                        
                        className={`p-0 ${(this.state.isOwner === 'Maison' ? 'btnradio' : 'btn-radio')} margin-small-0`}
                        onClick={() => this.handleRadioChange('Maison')}
                      >
                        <div className='radio-timg-sec'>
                        <div className={`radiotext ${(this.state.isOwner === 'Maison' ? 'svg-light' : 'svg-blue')}`}>
                            
                          </div>
                          <div className={`${(this.state.isOwner === 'Maison' ? 'text-light' : 'text-blue')} m-0 display-on-off`}>Maison</div>
                         
                        </div>
                      </Button>
                      <Button type='radio' value={'Appartement'}                       
                      className={`p-0 ${(this.state.isOwner === 'Appartement' ? 'btnradio' : 'btn-radio')}  margin-small-0`} 
                       active={this.state.isOwner === 'Appartement'} 
                      variant=""
                      onClick={() => this.handleRadioChange('Appartement')}
                      >
                            <div className='radio-timg-sec'>
                              <div className={`radiotext ${(this.state.isOwner === 'Appartement' ? 'svg-light' : 'svg-blue')}`}>
                               
                              </div>
                              <div className={`${(this.state.isOwner === 'Appartement' ? 'text-light' : 'text-blue')} m-0 display-on-off`}>Appartement</div>

                            </div>
                      </Button>
                     
                      </div>
                    </Row>
                    {
                      this.state.isOwner === 'Appartement' ? <div className='d-flex align-items-center'><p style={{ float: "right" }} className='text-danger m-0'><span className='text-danger m-0' style={{ fontWeight: "bold", fontSize: "25px" }}>&#8594;</span> Offre uniquement pour une maison</p></div> : <></>
                    }
                  </div>
                  <div className="">
                    <label htmlFor="autoCompleteInput" className='label-class mb-2'>Quelle est votre adresse ?</label>
                    <AutoCompleteMain parentHandleInput={(e) => this.handleChildData(e)} colorCodeRgb={this.state.colorCodeRgb}/>
                  </div>
                 
                  <div class="mt-4">
                    <label for="customRange1" class="label-class ">
                      Quel est le montant mensuel de votre facture d’électricité ?
                    </label>
                    <ThemeProvider theme={this.state.sliderTheme}>
                    <Slider class="form-range"   min={40} max={500} defaultValue={250}
                      step={10} marks={this.state.marks} aria-label="Always visible" onChange={this.setMonthlyInvoice} valueLabelDisplay="auto"
                      valueLabelFormat={(value) => `${value} €`} />
                      </ThemeProvider>
                    {
                      this.state.valueLow ? <div className='d-flex align-items-center justify-content-end'><p style={{ float: "right" }} className='text-danger m-0'><span className='text-danger m-0' style={{ fontWeight: "bold", fontSize: "25px" }}>&#8594;</span> Facture trop basse pour passer au solaire</p></div> : <></>
                    }
                  </div>
<div className='w-100 btn-right'>
                  <Button
                    // variant="warning"
                    variant={(!this.state.valueLow && this.state.placeSelected) && this.state.isOwner !== 'Appartement' ? "secondary" : "secondary"}
                    disabled={this.state.valueLow || !this.state.placeSelected || this.state.isOwner === 'Appartement'}
                    onClick={() => handleNext(0)}
                    className={` text-light ${(this.state.valueLow ? 'my-3' : 'my-3')}`}
                  >
                     J'identifie ma maison
                  </Button>
                  </div>
                </div>
              )}













              </div>
<div style={{clear:'both', overflow:'hidden'}}></div>
            </div>
          </div>
          {
            step == 1 &&

            <>
            <div className='first-button-wrapper my-1'>
            <Button
              // variant="warning"
              variant={"flat"}

              onClick={handleFastForward}
              className={` text-light ${(this.state.valueLow ? 'my-3' : '')} `}
            >
               Je ne trouve pas ma maison
            </Button>
              <Button
              // variant="warning"
              variant={"secondary"}

              onClick={() => handleNext(1)}
              className={` text-light ${(this.state.valueLow ? 'my-3' : '')} `}
            >
               Je lance l’analyse de mon potentiel solaire
            </Button>
            </div>
            {/* <div className='first-button-wrapper  my-1'> 
            </div> */}
            </>
          }

          {step === 2 && ( this.state.shadowSteps === 3) && !this.state.loading && (
            <>
              <label className='big-title' style={{ display: `${(( this.state.shadowSteps === 3 ) && !this.state.loading ? 'block' : 'none')}` }}>{`Nous n’avons pas réussi à analyser votre toiture !
Donnez-nous ses caractéristiques :`}
             </label>
              <div className='voter-box-grid-main'>
                <label className='label-class'>Quelle est la taille de votre toiture ?
                </label>
                <div className='voter-box-grid w-100 d-flex'>
                  <div className='voter-box'>
                    <Button
                      variant=""
                      onClick={() => handleButtonClick('petite',0)}
                      className={`voter-box-btn ${this.state.activeButtonRow1 === 'petite' ? 'voter-box-btn-red border-danger' : 'voter-box-btn-black border-dark'}`}
                    >
                      <svg width="115" height="90" viewBox="0 0 115 90" fill="none" xmlns="http://www.w3.org/2000/svg" className='img-fluid img-fluid-auto'>
                        <path d="M22 65.6994L54.3998 25.3604C54.9356 24.8799 55.7473 24.8799 56.2833 25.3604L70.1876 45.2454V35.3422C70.1876 34.5631 70.8194 33.9315 71.5984 33.9315H80.9997C81.7788 33.9315 82.4105 34.5631 82.4105 35.3422V56.2046L93 65.6994" stroke={this.state.colorCodeRgb} stroke-width="4" />
                      </svg>

                      {/* <img src={require('../assets/image_icon_Screen/smallFace.svg')} className='img-fluid img-fluid-auto' /> */}
                      <div className={`voter-box-text ${this.state.activeButtonRow1 === 'petite' ? ' text-danger' : ' text-dark'}`}> <span>Petite</span><span>&lt; 20 m2</span></div>
                    </Button>
                  </div>
                  <div className='voter-box'>
                    <Button
                      variant=""
                      onClick={() => handleButtonClick('moyenne',1)}
                      className={`voter-box-btn ${this.state.activeButtonRow1 === 'moyenne' ? 'voter-box-btn-red border-danger' : 'voter-box-btn-black border-dark'}`}
                    >
                      <svg width="115" height="90" viewBox="0 0 115 90" fill="none" xmlns="http://www.w3.org/2000/svg" className='img-fluid img-fluid-auto'>
                        <path d="M18 68L53.8234 23.3985C54.4158 22.8672 55.3134 22.8672 55.9059 23.3985L71.2795 45.3847V34.4351C71.2795 33.5736 71.978 32.8753 72.8394 32.8753H83.2341C84.0955 32.8753 84.794 33.5736 84.794 34.4351V57.502L96.5024 68" stroke={this.state.colorCodeRgb} stroke-width="4" />
                      </svg>

                      {/* <img src={require('../assets/image_icon_Screen/mediumFace.svg')} className='img-fluid img-fluid-auto' /> */}
                      <div className={`voter-box-text ${this.state.activeButtonRow1 === 'moyenne' ? ' text-danger' : ' text-dark'}`}><span>Moyenne</span><span>20 - 40 m2</span></div>
                    </Button>
                  </div>
                  <div className='voter-box'>
                    <Button
                      variant=""
                      onClick={() => handleButtonClick('grande',2)}
                      className={`voter-box-btn ${this.state.activeButtonRow1 === 'grande' ? 'voter-box-btn-red border-danger' : 'voter-box-btn-black border-dark'}`}
                    >
                      <svg width="115" height="90" viewBox="0 0 115 90" fill="none" xmlns="http://www.w3.org/2000/svg" className='img-fluid img-fluid-auto'>
                        <path d="M14 70L53.8038 20.4427C54.462 19.8524 55.4593 19.8524 56.1177 20.4427L73.1995 44.8719V32.7057C73.1995 31.7484 73.9756 30.9725 74.9326 30.9725H86.4824C87.4394 30.9725 88.2155 31.7484 88.2155 32.7057V58.3355L101.225 70" stroke={this.state.colorCodeRgb} stroke-width="4" />
                      </svg>
                      {/* <img src={require('../assets/image_icon_Screen/bigFace.svg')} className='img-fluid img-fluid-auto' /> */}
                      <div className={`voter-box-text ${this.state.activeButtonRow1 === 'grande' ? ' text-danger' : ' text-dark'}`}> <span>Grande</span><span>40 - 60 m2</span></div>
                    </Button>
                  </div>
                  <div className='voter-box'>
                    <Button
                      variant=""
                      onClick={() => handleButtonClick('tres_grande',3)}
                      className={`voter-box-btn ${this.state.activeButtonRow1 === 'tres_grande' ? 'voter-box-btn-red border-danger' : 'voter-box-btn-black border-dark'}`}
                    >
                      <svg width="115" height="90" viewBox="0 0 115 90" fill="none" xmlns="http://www.w3.org/2000/svg" className='img-fluid img-fluid-auto'>
<path d="M8 73.567L53.0316 17.5009C53.7763 16.833 54.9045 16.833 55.6494 17.5009L74.9747 45.1385V31.3744C74.9747 30.2915 75.8527 29.4136 76.9355 29.4136H90.0022C91.0849 29.4136 91.9629 30.2915 91.9629 31.3744V60.3705L106.681 73.567" stroke={this.state.colorCodeRgb} stroke-width="4"/>
</svg>
                      {/* <img src={require('../assets/image_icon_Screen/verybigFace.svg')} className='img-fluid img-fluid-auto' /> */}
                      <div className={`voter-box-text ${this.state.activeButtonRow1 === 'tres_grande' ? ' text-danger' : ' text-dark'}`}><span>Très Grande</span><span>60 - 350 m2</span></div>
                    </Button>
                  </div>
                </div>
              </div>
              <div className='voter-box-grid-main2'>
                <label className='label-class'>Quelle est l’orientation de votre toiture ?
                </label>
                <div className='voter-box-grid2'>
                  <div className='voter-box2'>
                    <Button
                      variant=""
                      onClick={() => handleButtonClick2('southF',0)}
                      className={`voter-box-btn2 ${this.state.activeButtonRow2 === 'southF' ? 'voter-box-btn-red2 border-danger' : 'voter-box-btn-black2 border-dark'}`}
                      style={{ }} // Height set to 180px
                    >
                      <svg width="200" height="170" viewBox="0 0 200 170" fill="none" xmlns="http://www.w3.org/2000/svg" className='fase-svg'>
                        <path d="M72.5 80.5L27 81.5L38.5 57.5L46.5 55.5V46.5L60.5 44L61.5 52L105 39L103 42L72.5 80.5Z" fill={this.state.colorCodeRgb} />
                        <path d="M34.5 81H80V144.902L34.5 118.634V81Z" stroke={this.state.colorCodeRgb} stroke-width="3" stroke-linejoin="round" />
                        <path d="M105 40.5L73 77.5V80.5H80V145.5L124.5 122.5V77.5H133L105 40.5Z" stroke={this.state.colorCodeRgb} stroke-width="3" stroke-linejoin="round" />
                        <path d="M98 134.5V88.5H111V129L98 134.5Z" fill={this.state.colorCodeRgb} />
                        <path d="M41 91.5L50 92.5V110.5L41 109.5V91.5Z" fill={this.state.colorCodeRgb} />
                        <path d="M57 93.5L70 95.5V113.5L57 111.5V93.5Z" fill={this.state.colorCodeRgb} />
                        <path d="M174.184 53.9999C174.186 56.436 173.218 58.772 171.497 60.4956C169.775 62.2192 167.439 63.1872 165.003 63.1888C162.567 63.1888 160.231 62.2223 158.507 60.5002C156.784 58.7782 155.816 56.442 155.816 54.0061C155.816 51.5702 156.782 49.2324 158.506 47.5104C160.228 45.7883 162.564 44.8203 165 44.8203C167.434 44.8203 169.77 45.7868 171.492 47.5088C173.214 49.2294 174.183 51.5652 174.184 53.9999ZM165 39L162.85 42.7257L167.15 42.7273L165 39ZM167.15 65.265H162.85L165 69L167.15 65.265ZM150 53.9999L153.726 56.1498L153.727 51.85L150 53.9999ZM176.265 51.85V56.1498L180 53.9999L176.265 51.85ZM175.608 43.3919L171.451 44.5077L174.492 47.5486L175.608 43.3919ZM158.549 63.5012L155.508 60.4603L154.392 64.6075L158.549 63.5012ZM154.392 43.3919L155.508 47.5487L158.549 44.5077L154.392 43.3919ZM174.501 60.4511L171.46 63.4921L175.617 64.6078L174.501 60.4511Z" fill={this.state.colorCodeRgb} />
                      </svg>

                      {/* <img src={require('../assets/image_icon_Screen/SouthFace.png')} className='fase-img' /> */}
                      <div className={`voter-box-text2 ${this.state.activeButtonRow2 === 'southF' ? ' text-danger' : ' text-dark'}`}>Sud</div>
                    </Button>
                  </div>
                  <div className='voter-box2'>
                  <Button
                      variant=""
                      onClick={() => handleButtonClick2('southEastF',1)}
                      className={`voter-box-btn2 ${this.state.activeButtonRow2 === 'southEastF' ? 'voter-box-btn-red2 border-danger' : 'voter-box-btn-black2 border-dark'}`}
                      // Height set to 180px
                    >
                      <svg width="200" height="170" viewBox="0 0 200 170" fill="none" xmlns="http://www.w3.org/2000/svg" className='fase-svg'>
                        <path d="M72.5 90.5L27 91.5L38.5 67.5L46.5 65.5V56.5L60.5 54L61.5 62L105 49L103 52L72.5 90.5Z" fill={this.state.colorCodeRgb} />
                        <path d="M34.5 91H80V154.902L34.5 128.634V91Z" stroke={this.state.colorCodeRgb} stroke-width="3" stroke-linejoin="round" />
                        <path d="M105 50.5L73 87.5V90.5H80V155.5L124.5 132.5V87.5H133L105 50.5Z" stroke={this.state.colorCodeRgb} stroke-width="3" stroke-linejoin="round" />
                        <path d="M98 144.5V98.5H111V139L98 144.5Z" fill={this.state.colorCodeRgb} />
                        <path d="M41 101.5L50 102.5V120.5L41 119.5V101.5Z" fill={this.state.colorCodeRgb} />
                        <path d="M57 103.5L70 105.5V123.5L57 121.5V103.5Z" fill={this.state.colorCodeRgb} />
                        <path d="M161.184 26.9999C161.186 29.436 160.218 31.772 158.497 33.4956C156.775 35.2192 154.439 36.1872 152.003 36.1888C149.567 36.1888 147.231 35.2223 145.507 33.5002C143.784 31.7782 142.816 29.442 142.816 27.0061C142.816 24.5702 143.782 22.2324 145.506 20.5104C147.228 18.7883 149.564 17.8203 152 17.8203C154.434 17.8203 156.77 18.7868 158.492 20.5088C160.214 22.2294 161.183 24.5652 161.184 26.9999ZM152 12L149.85 15.7257L154.15 15.7273L152 12ZM154.15 38.265H149.85L152 42L154.15 38.265ZM137 26.9999L140.726 29.1498L140.727 24.85L137 26.9999ZM163.265 24.85V29.1498L167 26.9999L163.265 24.85ZM162.608 16.3919L158.451 17.5077L161.492 20.5486L162.608 16.3919ZM145.549 36.5012L142.508 33.4603L141.392 37.6075L145.549 36.5012ZM141.392 16.3919L142.508 20.5487L145.549 17.5077L141.392 16.3919ZM161.501 33.4511L158.46 36.4921L162.617 37.6078L161.501 33.4511Z" fill={this.state.colorCodeRgb} />
                      </svg>

                      {/* <img src={require('../assets/image_icon_Screen/SouthEastFace.png')} className='fase-img' /> */}
                      <div className={`voter-box-text2 ${this.state.activeButtonRow2 === 'southEastF' ? ' text-danger' : ' text-dark'}`}><span>Sud-Est ou <br /> Sud-Ouest</span></div>
                    </Button>
                  </div>
                  <div className='voter-box2'>
                  <Button
                      variant=""
                      onClick={() => handleButtonClick2('westEastF',2)}
                      className={`voter-box-btn2 ${this.state.activeButtonRow2 === 'westEastF' ? 'voter-box-btn-red2 border-danger' : 'voter-box-btn-black2 border-dark'}`}
                      // Height set to 180px
                    >
                      <svg width="200" height="170" viewBox="0 0 200 170" fill="none" xmlns="http://www.w3.org/2000/svg" className='fase-svg'>
                        <path d="M92.5 90.5L47 91.5L58.5 67.5L66.5 65.5V56.5L80.5 54L81.5 62L125 49L123 52L92.5 90.5Z" fill={this.state.colorCodeRgb} />
                        <path d="M54.5 91H100V154.902L54.5 128.634V91Z" stroke={this.state.colorCodeRgb} stroke-width="3" stroke-linejoin="round" />
                        <path d="M125 50.5L93 87.5V90.5H100V155.5L144.5 132.5V87.5H153L125 50.5Z" stroke={this.state.colorCodeRgb} stroke-width="3" stroke-linejoin="round" />
                        <path d="M118 144.5V98.5H131V139L118 144.5Z" fill={this.state.colorCodeRgb} />
                        <path d="M61 101.5L70 102.5V120.5L61 119.5V101.5Z" fill={this.state.colorCodeRgb} />
                        <path d="M77 103.5L90 105.5V123.5L77 121.5V103.5Z" fill={this.state.colorCodeRgb} />
                        <path d="M109.184 26.9999C109.186 29.436 108.218 31.772 106.497 33.4956C104.775 35.2192 102.439 36.1872 100.003 36.1888C97.5668 36.1888 95.2308 35.2223 93.5072 33.5002C91.7836 31.7782 90.8156 29.442 90.8156 27.0061C90.8156 24.5702 91.7821 22.2324 93.5057 20.5104C95.2277 18.7883 97.5639 17.8203 99.9998 17.8203C102.434 17.8203 104.77 18.7868 106.492 20.5088C108.214 22.2294 109.183 24.5652 109.184 26.9999ZM99.9999 12L97.85 15.7257L102.15 15.7273L99.9999 12ZM102.15 38.265H97.85L99.9999 42L102.15 38.265ZM85 26.9999L88.7257 29.1498L88.7273 24.85L85 26.9999ZM111.265 24.85V29.1498L115 26.9999L111.265 24.85ZM110.608 16.3919L106.451 17.5077L109.492 20.5486L110.608 16.3919ZM93.5487 36.5012L90.5077 33.4603L89.392 37.6075L93.5487 36.5012ZM89.3919 16.3919L90.5077 20.5487L93.5486 17.5077L89.3919 16.3919ZM109.501 33.4511L106.46 36.4921L110.617 37.6078L109.501 33.4511Z" fill={this.state.colorCodeRgb} />
                      </svg>

                      {/* <img src={require('../assets/image_icon_Screen/WestEastFace.png')} className='fase-img' /> */}
                      <div className={`voter-box-text2 ${this.state.activeButtonRow2 === 'westEastF' ? ' text-danger' : ' text-dark'}`}> Est/Ouest</div>
                    </Button>
                  </div>
                  <div className='voter-box2'>
                  <Button
                      variant=""
                      onClick={() => handleButtonClick2('northF',3)}
                      className={`voter-box-btn2  ${this.state.activeButtonRow2 === 'northF' ? 'voter-box-btn-red2 border-danger' : 'voter-box-btn-black2 border-dark'}`}
                       // Height set to 180px
                    >
                      <svg width="200" height="170" viewBox="0 0 200 170" fill="none" xmlns="http://www.w3.org/2000/svg" className='fase-svg'>
                        <path d="M119.5 80.5L74 81.5L85.5 57.5L93.5 55.5V46.5L107.5 44L108.5 52L152 39L150 42L119.5 80.5Z" fill={this.state.colorCodeRgb} />
                        <path d="M81.5 81H127V144.902L81.5 118.634V81Z" stroke={this.state.colorCodeRgb} stroke-width="3" stroke-linejoin="round" />
                        <path d="M152 40.5L120 77.5V80.5H127V145.5L171.5 122.5V77.5H180L152 40.5Z" stroke={this.state.colorCodeRgb} stroke-width="3" stroke-linejoin="round" />
                        <path d="M145 134.5V88.5H158V129L145 134.5Z" fill={this.state.colorCodeRgb} />
                        <path d="M88 91.5L97 92.5V110.5L88 109.5V91.5Z" fill={this.state.colorCodeRgb} />
                        <path d="M104 93.5L117 95.5V113.5L104 111.5V93.5Z" fill={this.state.colorCodeRgb} />
                        <path d="M43.1841 53.9999C43.1856 56.436 42.2176 58.772 40.4971 60.4956C38.775 62.2192 36.4388 63.1872 34.0029 63.1888C31.5668 63.1888 29.2308 62.2223 27.5072 60.5002C25.7836 58.7782 24.8156 56.442 24.8156 54.0061C24.8156 51.5702 25.7821 49.2324 27.5057 47.5104C29.2277 45.7883 31.5639 44.8203 33.9998 44.8203C36.4344 44.8203 38.7704 45.7868 40.4924 47.5088C42.2145 49.2294 43.1825 51.5652 43.1841 53.9999ZM33.9999 39L31.85 42.7257L36.1498 42.7273L33.9999 39ZM36.1498 65.265H31.85L33.9999 69L36.1498 65.265ZM19 53.9999L22.7257 56.1498L22.7273 51.85L19 53.9999ZM45.265 51.85V56.1498L49 53.9999L45.265 51.85ZM44.6079 43.3919L40.4511 44.5077L43.4921 47.5486L44.6079 43.3919ZM27.5487 63.5012L24.5077 60.4603L23.392 64.6075L27.5487 63.5012ZM23.3919 43.3919L24.5077 47.5487L27.5486 44.5077L23.3919 43.3919ZM43.5012 60.4511L40.4603 63.4921L44.617 64.6078L43.5012 60.4511Z" fill={this.state.colorCodeRgb} />
                      </svg>

                      {/* <img src={require('../assets/image_icon_Screen/NorthFace.png')} className='fase-img' /> */}
                      <div className={`voter-box-text2 ${this.state.activeButtonRow2 === 'northF' ? ' text-danger' : ' text-dark'}`}><span>Orienté Nord ou</span><span> très ombragée</span></div>
                    </Button>
                  </div>
                  <div className='voter-box2'>
                    <Button
                      variant=""
                      onClick={() => handleButtonClick2('flatRoof',4)}
                      className={`voter-box-btn2  ${this.state.activeButtonRow2 === 'flatRoof' ? 'voter-box-btn-red2 border-danger' : 'voter-box-btn-black2 border-dark'}`}
                      // Height set to 180px
                    >
                      <svg width="200" height="170" viewBox="0 0 200 170" fill="none" xmlns="http://www.w3.org/2000/svg" className='fase-svg'>
                        <path d="M67.5 48L27 60V70L67.5 60L88.5 68L110 64.5L67.5 48Z" stroke={this.state.colorCodeRgb} stroke-width="3" stroke-linejoin="round" />
                        <path d="M66 122H33V68.5L66 60V122ZM66 122H73" stroke={this.state.colorCodeRgb} stroke-width="3" stroke-linejoin="round" />
                        <path d="M128.5 61L66 73.5V83.5L128.5 75M128.5 61L173.5 78V87H168.5L128.5 75M128.5 61V75" stroke={this.state.colorCodeRgb} stroke-width="3" stroke-linejoin="round" />
                        <path d="M73 83L128 75V122H73V83Z" stroke={this.state.colorCodeRgb} stroke-width="3" />
                        <path d="M168 87L128 75V122H168V87Z" stroke={this.state.colorCodeRgb} stroke-width="3" />
                        <path d="M81.8586 97.0101C81.3659 97.0804 81 97.5023 81 98V109C81 109.29 81.1258 109.566 81.3448 109.755C81.5638 109.945 81.8544 110.031 82.1414 109.99L89.1414 108.99C89.6341 108.92 90 108.498 90 108V97C90 96.7101 89.8742 96.4345 89.6552 96.2445C89.4362 96.0546 89.1456 95.9691 88.8586 96.0101L81.8586 97.0101Z" stroke={this.state.colorCodeRgb} stroke-width="2" stroke-linejoin="round" />
                        <path d="M45.6702 94.5016C45.2688 94.6418 45 95.0205 45 95.4457V120C45 120.268 45.1073 120.524 45.2979 120.712C45.4884 120.9 45.7464 121.004 46.014 121L53.014 120.902C53.5608 120.894 54 120.449 54 119.902V93C54 92.676 53.843 92.3721 53.5789 92.1846C53.3147 91.997 52.976 91.9491 52.6702 92.056L45.6702 94.5016Z" stroke={this.state.colorCodeRgb} stroke-width="2" stroke-linejoin="round" />
                        <path d="M96.8586 95.0101C96.3659 95.0804 96 95.5023 96 96V107C96 107.29 96.1258 107.566 96.3448 107.755C96.5638 107.945 96.8544 108.031 97.1414 107.99L104.141 106.99C104.634 106.92 105 106.498 105 106V95C105 94.7101 104.874 94.4345 104.655 94.2445C104.436 94.0546 104.146 93.9691 103.859 94.0101L96.8586 95.0101Z" stroke={this.state.colorCodeRgb} stroke-width="2" stroke-linejoin="round" />
                        <path d="M111.859 93.0101C111.366 93.0804 111 93.5023 111 94V106C111 106.29 111.126 106.566 111.345 106.755C111.564 106.945 111.854 107.031 112.141 106.99L119.141 105.99C119.634 105.92 120 105.498 120 105V93C120 92.7101 119.874 92.4345 119.655 92.2445C119.436 92.0546 119.146 91.9691 118.859 92.0101L111.859 93.0101Z" stroke={this.state.colorCodeRgb} stroke-width="2" stroke-linejoin="round" />
                      </svg>

                      {/* <img src={require('../assets/image_icon_Screen/FlatRoof.png')} className='fase-img' /> */}
                      <div className={`voter-box-text2 ${this.state.activeButtonRow2 === 'flatRoof' ? ' text-danger' : ' text-dark'}`}><span>Toit plat</span></div>
                    </Button>
                  </div>
                  <div className='voter-box2'>
                  <Button
                      variant=""
                      onClick={() => handleButtonClick2('doNot',5)}
                      className={`voter-box-btn2  ${this.state.activeButtonRow2 === 'doNot' ? 'voter-box-btn-red2 border-danger' : 'voter-box-btn-black2 border-dark'}`}
                      // Height set to 180px
                    >
                      <svg width="200" height="170" viewBox="0 0 200 170" fill="none" xmlns="http://www.w3.org/2000/svg" className='fase-svg'>
                        <path d="M110 12C108.022 12 106.089 12.5865 104.444 13.6853C102.8 14.7841 101.518 16.3459 100.761 18.1732C100.004 20.0004 99.8063 22.0111 100.192 23.9509C100.578 25.8907 101.53 27.6725 102.929 29.0711C104.327 30.4696 106.109 31.422 108.049 31.8078C109.989 32.1937 112 31.9957 113.827 31.2388C115.654 30.4819 117.216 29.2002 118.315 27.5557C119.414 25.9112 120 23.9778 120 22C120 19.3478 118.946 16.8043 117.071 14.9289C115.196 13.0536 112.652 12 110 12ZM109.864 28.5787C109.637 28.5787 109.416 28.5116 109.228 28.3858C109.04 28.26 108.893 28.0813 108.806 27.8721C108.72 27.6629 108.697 27.4328 108.741 27.2107C108.785 26.9887 108.894 26.7847 109.054 26.6246C109.215 26.4645 109.418 26.3555 109.641 26.3114C109.863 26.2672 110.093 26.2899 110.302 26.3765C110.511 26.4631 110.69 26.6098 110.816 26.7981C110.941 26.9863 111.009 27.2076 111.009 27.434C111.008 27.7375 110.887 28.0283 110.673 28.2428C110.458 28.4574 110.167 28.5782 109.864 28.5787ZM111.115 23.0213C111.115 23.0213 111.002 23.0617 111.002 23.1277V24.0362C111.002 24.3383 110.882 24.6281 110.668 24.8418C110.455 25.0555 110.165 25.1755 109.863 25.1755C109.561 25.1755 109.271 25.0555 109.057 24.8418C108.843 24.6281 108.723 24.3383 108.723 24.0362V23.1277C108.728 22.6236 108.891 22.1338 109.19 21.7272C109.488 21.3207 109.906 21.018 110.385 20.8617C110.716 20.7514 111.002 20.5373 111.201 20.2513C111.4 19.9653 111.501 19.6227 111.489 19.2745C111.467 18.8534 111.286 18.4565 110.982 18.1642C110.678 17.8718 110.275 17.7059 109.853 17.7C109.55 17.7013 109.253 17.7883 108.996 17.9509C108.74 18.1135 108.535 18.3451 108.404 18.6191C108.339 18.754 108.248 18.8747 108.137 18.9744C108.025 19.074 107.895 19.1508 107.754 19.2002C107.468 19.2999 107.155 19.2823 106.883 19.1511C106.611 19.0199 106.402 18.7859 106.302 18.5006C106.202 18.2153 106.22 17.9021 106.351 17.6298C106.665 16.9714 107.159 16.4149 107.775 16.0243C108.391 15.6336 109.105 15.4246 109.834 15.4213H109.857C110.871 15.4272 111.843 15.8241 112.571 16.5294C113.299 17.2346 113.726 18.1936 113.764 19.2064C113.792 20.0422 113.55 20.8648 113.073 21.5518C112.596 22.2387 111.91 22.7534 111.117 23.0191L111.115 23.0213Z" fill={this.state.colorCodeRgb} />
                        <path d="M92.5 80.5L47 81.5L58.5 57.5L66.5 55.5V46.5L80.5 44L81.5 52L125 39L123 42L92.5 80.5Z" fill={this.state.colorCodeRgb} />
                        <path d="M54.5 81H100V144.902L54.5 118.634V81Z" stroke={this.state.colorCodeRgb} stroke-width="3" stroke-linejoin="round" />
                        <path d="M125 40.5L93 77.5V80.5H100V145.5L144.5 122.5V77.5H153L125 40.5Z" stroke={this.state.colorCodeRgb} stroke-width="3" stroke-linejoin="round" />
                        <path d="M118 134.5V88.5H131V129L118 134.5Z" fill={this.state.colorCodeRgb} />
                        <path d="M61 91.5L70 92.5V110.5L61 109.5V91.5Z" fill={this.state.colorCodeRgb} />
                        <path d="M77 93.5L90 95.5V113.5L77 111.5V93.5Z" fill={this.state.colorCodeRgb} />
                      </svg>

                      {/* <img src={require('../assets/image_icon_Screen/DontKnowFace.png')}className='fase-img' /> */}
                      <div className={`voter-box-text2 ${this.state.activeButtonRow2 === 'doNot' ? ' text-danger' : ' text-dark'}`}>
                        <span>Je ne sais pas</span></div>
                    </Button>
                  </div>
                </div>
              </div>

              <div className='voter-box-grid-main3 my-2 mx-3'>
                <Button
                  
                  onClick={() => handleNext(2)}
                  disabled={!this.state.activeButtonRow2 || !this.state.activeButtonRow1}
                  variant={(this.state.activeButtonRow2 && this.state.activeButtonRow1? "secondary" : "secondary")}
                  className={`text-light`}
                >
                   Mes économies en passant au solaire ?
                </Button>
              </div>

            </>
          )
          }  {(
            step === 2 && !this.state.loading && this.state.shadowSteps === 2 && (
              <div className='sui-button-wrapper'>
                <div className='button-wrapper'>
                <Button
                  variant={'secondary'}
                  onClick={handleFastForwardSecond}
                  className={`text-light flex-stretch h-100`}
                >
                   Ce n’est pas ma maison
                </Button>
                </div>
                <div className='button-wrapper'>
                <Button

                  disabled={!this.state.maxRoof}
                  variant={(this.state.maxRoof? "flat" : "secondary")}
                  onClick={handleNextKO}
                  className={`text-light flex-stretch h-100`}
                >
                   Suivant
                </Button>
                </div>
              </div>
            )
          )}

          {
            step === 2 && this.state.shadowSteps === 4 && !this.state.secondLoader && (
              <>
              <div className='bonne-sec'>
                <div className='text-center'>
                <label className='big-title1'>
                  {`
Bonne nouvelle ! `}
                </label>
                </div>
                <label className='label-class w-100 mx-auto mb-3 label-col'>
                  <span>{`Votre maison va réaliser des économies`}</span>
                  <span>{`d'énergie sur la base de l'analyse suivante`}</span>
                </label>

                <div className='two-col-row'>
                  <div className='two-col'><label htmlFor="sunshinePerYear" className='label-class'>Productible annuel </label>
                    <input
                      type="text"
                      disabled
                      className="form-control"
                      id="sunshinePerYear"
                      value={this.state.maxRoof && !this.state.isManual ? Math.round(this.state.maxRoof.productible)+' kWh / kWc ' : this.state.manualProductible + ' kWh / kWc '}
                    /// Set your default or empty value here
                    /></div>
                  <div className='two-col'><label htmlFor="surface" className='label-class'>Surface exploitable </label>
                    <input
                      type="text"
                      disabled
                      className="form-control"
                      id="surface"
                      value={this.state.maxRoof && !this.state.isManual?Math.round(this.state.maxRoof.stats.areaMeters2)+ ' m2' :this.state.areaMeters2Manual  + ' m2'}
                    />
                  </div>
                </div>
                {/* <Row className="mb-2">
                    <Col></Col>
                    <Col></Col>
                    </Row> */}
                 <div className='two-col-row'>
                  <div className='two-col'><label htmlFor="orientation" className='label-class'>Orientation (Sud = 0°) </label>
                    <input
                      type="text"
                      disabled
                      className="form-control"
                      id="orientation"
                      value={(this.state.maxRoof && this.state.maxRoof.azimuthDegrees < 1 && this.state.maxRoof.azimuthDegrees >= 0)
                        ? 0 + ' °' : this.state.maxRoof && !this.state.isManual?Math.round((this.state.maxRoof.azimuthDegrees - 180)) + ' °':this.state.orientationManual + ' °'}
                    /></div>
                  <div className='two-col'><label htmlFor="pitch" className='label-class'>Inclinaison </label>
                    <input
                      type="text"
                      className="form-control"
                      id="pitch"
                      disabled
                      value={this.state.maxRoof && !this.state.isManual?Math.round(this.state.maxRoof.pitchDegrees)+ ' °' :this.state.inclinaisonManual+ ' °'}
                    />
                  </div>
                </div>
                <div className='bonne-btn-sec'>
                  <Button
                    variant="secondary"
                    onClick={() => handleNext(3)}
                    className={`text-light`}
                  >
                     Je calcule mes économies avec le solaire
                  </Button>
                </div>
                {/* <Row className="mb-2">
                  <Col></Col>
                  <Col></Col>
                </Row> */}
                </div>
              </>
            )
          }

          {
            step === 2 && this.state.shadowSteps === 5 && (
                <div className='main-wrapper-five bonne-sec'>
                  <div className='heading-wrapper text-center mb-5'>
                    <label className='big-title w-100 mx-auto mb-3 label-col'>
                      <span>{`Dites nous en plus sur vous`}</span>
                      <span>{`et vos équipements pour mieux dimensionner`}</span>
                    </label>
                  </div>
                  <div className='content-wrapper-five'>
                    <Row className='mb-4 align-items-center'>
                      <Col md={6}>
                        <label className='label-class'>
                          Votre situation ?
                        </label>
                      </Col>
                      <Col md={6}>
                        <select
                          className="form-control no-shadow "
                          name="echeance"
                          value={this.state.yourSituation}
                          onChange={(e) => {
                            const selectedValue = e.target.value;
                            this.setState({ yourSituation: selectedValue })
                          }}
                        >
                          <option value="Actif">Actif</option>
                          <option value="Retraité">Retraité</option>
                          <option value="En télétravail 1 jour / semaine">En télétravail 1 jour / semaine</option>
                          <option value="En télétravail 2 jours / semaine">En télétravail 2 jours / semaine</option>
                          <option value="En télétravail 3 jours / semaine">En télétravail 3 jours / semaine</option>
                        </select>
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={6}>
                        <label className='label-class label-col-not-center'>
                          <span>Quel type de climatisation possédez vous ?</span>
                        </label>
                      </Col>
                      <Col md={6}>
                        <select
                          className="form-control no-shadow "
                          name=""
                          value={this.state.typeOfAC}
                          onChange={(e) => {
                            const selectedValue = e.target.value;
                            this.setState({ typeOfAC: selectedValue })
                          }}
                        >
                          <option value="Sans climatisation">Sans climatisation</option>
                          <option value="Climatisation  (PAC air/air)">Climatisation  (PAC air/air)</option>
                          <option value="Autre ou je ne sais pas">Autre ou je ne sais pas</option>
                        </select>
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={6}>
                        <label className='label-class label-col-not-center'>
                          <span>Quel type de chauffage possédez vous ?
                          </span>
                        </label>
                      </Col>
                      <Col md={6}>
                        <select
                          className="form-control no-shadow"
                          name=""
                          value={this.state.typeOfHeating}
                          onChange={(e) => {
                            const selectedValue = e.target.value;
                            this.setState({ typeOfHeating: selectedValue })
                          }}
                        >
                          <option value="Chauffage au gaz, fioul ou bois">Chauffage au gaz, fioul ou bois</option>
                          <option value="Climatisation réversible (PAC air/air)">Climatisation réversible (PAC air/air)</option>
                          <option value="Pompe à chaleur Air / eau">Pompe à chaleur Air / eau</option>
                          <option value="Chauffage électrique">Chauffage électrique</option>
                          <option value="Autre ou je ne sais pas">Autre ou je ne sais pas</option>
                        </select>
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={6}>
                        <label className='label-class label-col-not-center'>
                          <span>Ǫuel est votre chauffage pour l’eau sanitaire ?</span>
                        </label>
                      </Col>
                      <Col md={6}>
                        <select
                          className="form-control no-shadow"
                          name="echeance"
                          value={this.state.domesticHeating}
                          onChange={(e) => {
                            const selectedValue = e.target.value;
                            this.setState({ heatType: selectedValue })
                          }}
                        >
                          <option value="Chauffe-eau électrique">Chauffe-eau électrique</option>
                          <option value="Ballon thermodynamique">Ballon thermodynamique</option>
                          <option value="Chauffe-eau solaire">Chauffe-eau solaire</option>
                          <option value="Chauffe-eau au gaz, fioul ou bois">Chauffe-eau au gaz, fioul ou bois</option>
                          <option value="Autre ou je ne sais pas">Autre ou je ne sais pas</option>

                        </select>
                      </Col>
                    </Row>
                    <Row className='mb-4'>
                      <Col md={6}>
                        <label className='label-class label-col-not-center'>
                          <span>Avez-vous une piscine ?</span>
                        </label>
                      </Col>
                      <Col md={6}>
                        <select
                          className="form-control no-shadow"
                          name="echeance"
                          value={this.state.hasPool}
                          onChange={(e) => {
                            const selectedValue = e.target.value;
                            this.setState({ hasPool: selectedValue })
                          }}
                        >
                          <option value="Pas de piscine">Pas de piscine</option>
                          <option value="Piscine de petite piscine">Piscine de petite piscine</option>
                          <option value="Piscine de moyenne piscine">Piscine de moyenne piscine</option>
                          <option value="Piscine de grande piscine">Piscine de grande piscine</option>
                        </select>
                      </Col>
                    </Row>
                  </div>
                  <div className='bonne-btn-sec'>
                    <Button
                      variant="flat"
                      onClick={handleNext}
                      className={`text-light`}
                    >  Je calcule mes économies
                    </Button>
                  </div>
                </div>
            )
          }


          {
            step === 3 && !this.state.secondLoader && !this.state.oneColumnTrigger && (
              <>
            
                <div class='table-wrapper'>
                  <table class="custom-table">
                    <thead>
                      <tr class='t-head'>
                        <th class="t-non-background"></th>
                        <td class="t-head-item bg-danger"><label class='table-label'><span>Offre 1er prix</span></label>
                          {/* accessibilité</label> */}
                        </td>
                        <td class="t-head-item bg-danger"><label class='table-label'><span>Offre recommandée</span></label>
                          {/* <span>rendement renforcé</span></label> */}
                        </td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr className='d-none'></tr>
                      <tr className='d-auto-none'>
                        <td colspan="2">
                          <div class='text-wrapper'>
                            <label class='table-label '>Prix d’achat TTC </label>
                            <p class='m-0 small-txt ' style={{ fontWeight: 500 }}>(aide déduite*)</p>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row" class='t-non-background'>
                          <div class='text-wrapper'>
                            <label class='table-label'>Prix d’achat TTC </label>
                            <p class='m-0 small-txt' style={{ fontWeight: 500 }}>(aide déduite*)</p>
                          </div>
                        </th>

                        <td class=' px-3'>

                          <div class='main-wrapper'> <label class='table-label big-label small-custom-txt'>à partir de {minimumSimulation ? (Math.floor(minimumSimulation.netPrice).toLocaleString('fr-FR')) : 0} €</label> <p class='small-txt m-0'>(Aide de {minimumSimulation ? (minimumSimulation.subsidy.toLocaleString('fr-FR')) : 0} €*)</p></div>
                        </td>
                        <td class=' px-3'>
                          <div class='main-wrapper'> <label class='table-label big-label small-custom-txt'>à partir de {recommendedSimulation ? (Math.floor(recommendedSimulation.netPrice).toLocaleString('fr-FR')) : 0} €</label> <p class='small-txt m-0'>(Aide de {recommendedSimulation ? (recommendedSimulation.subsidy.toLocaleString('fr-FR')) : 0} €*)</p></div>
                        </td>
                      </tr>
                      <tr className='d-none'></tr>
                      <tr className='d-auto-none'><td colSpan={2}>
                        <div class='text-wrapper'>
                          <label class='table-label '><span>Puissance</span><span>
                            Nombre de panneaux</span>
                          </label>
                        </div>
                      </td>
                      </tr>
                      <tr>
                        <th scope="row" class='t-non-background'>
                          <div class='text-wrapper'>
                            <label class='table-label '><span>Puissance</span><span>
                              Nombre de panneaux</span>
                            </label>
                          </div>
                        </th>
                        <td class=' px-3'>


                          <div class='main-wrapper'>
                          <label class='table-label big-label d-flex flex-row align-items-center justify-content-center'><span>{minimumSimulation ? minimumSimulation.recommandedPower : 0} kWc&nbsp;/</span><span>&nbsp; {minimumSimulation ? minimumSimulation.recommandedNbrPannels : 0} panneaux</span></label>
                          </div>
                        </td>
                        <td class='px-3'>
                        <label class='table-label big-label d-flex flex-row align-items-center justify-content-center'><span>{recommendedSimulation ? recommendedSimulation.recommandedPower : 0} kWc&nbsp;/</span><span>&nbsp; {recommendedSimulation ? recommendedSimulation.recommandedNbrPannels : 0} panneaux</span></label></td>
                      </tr>
                      <tr className='d-none'></tr>
                      <tr className='d-auto-none'><td colSpan={2}>
                        <div class='text-wrapper'>
                          <label class='table-label '><span>Garanties panneaux</span><span>
                            constructeur / Performance</span>
                          </label>
                        </div>
                      </td>
                      </tr>
                      <tr>
                        <th scope="row" class='t-non-background'>
                          <div class='text-wrapper'>
                          <label class='table-label '><span>Garanties panneaux</span><span>
                            constructeur / Performance</span>
                          </label>
                          </div>
                        </th>
                        <td class=' px-3'>


                          <div class='main-wrapper'>
                          <label class='table-label big-label d-flex flex-row align-items-center justify-content-center'><span>25 ans&nbsp;/</span><span>&nbsp; 25 ans</span></label>

                          </div>
                        </td>
                        <td class='px-3'>
                        <label class='table-label big-label d-flex flex-row align-items-center justify-content-center'><span>25 ans&nbsp;/</span><span>&nbsp; 25 ans</span></label></td>
                      </tr>
                      <tr className='d-none'></tr>
                      <tr className='d-auto-none'><td colSpan={2}>
                        <div class='text-wrapper'>
                          <label class='table-label '><span>Puissance des panneaux</span>
                          </label>
                        </div>
                      </td>
                      </tr>
                      <tr>
                        <th scope="row" class='t-non-background'>
                          <div class='text-wrapper'>
                            <label class='table-label '><span>Puissance des panneaux</span>
                            </label>
                          </div>
                        </th>
                        <td class=' px-3'>


                          <div class='main-wrapper'>
                            <label class='table-label big-label'><span>500 Wc</span></label>
                          </div>
                        </td>
                        <td class='px-3'>
                          <label class='table-label big-label'><span>500 Wc</span></label></td>
                      </tr>
                      <tr className='d-none'></tr>
                      <tr className='d-auto-none'>
                        <td colSpan={2}>
                          <div class='text-wrapper'>
                            <label class='table-label '><span>Economies  d’électricité</span><span>
                              dès la 1ere année*</span>
                            </label>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row" class='t-non-background'>
                          <div class='text-wrapper'>
                            <label class='table-label '><span>Economies  d’électricité</span><span>
                              dès la 1ere année*</span>
                            </label>
                          </div>
                        </th>
                        <td class=' px-3'>
                          <div class='main-wrapper'> <label class='table-label big-label'>{minimumSimulation ? (minimumSimulation.savingsFirstYear.toLocaleString('fr-FR')) : 0} €</label><p class='small-txt m-0'>(- {minimumSimulation ? minimumSimulation.savingsPercent : 0} % sur la facture)</p></div>
                        </td>
                        <td class=' px-3'>
                          <div class='main-wrapper'> <label class='table-label big-label'>{recommendedSimulation ? (recommendedSimulation.savingsFirstYear.toLocaleString('fr-FR')) : 0} €</label><p class='small-txt m-0'>(- {recommendedSimulation ? recommendedSimulation.savingsPercent : 0} % sur la facture)</p></div>
                        </td>
                      </tr>
                      <tr className='d-none'></tr>
                      <tr className='d-auto-none'><td colSpan={2}>
                        <div class='text-wrapper'>
                          <label class='table-label'><span>Economies d’électricité</span><span>sur 25 ans*</span></label>

                        </div></td></tr>
                      <tr>
                        <th scope="row" class='t-non-background'>
                          <div class='text-wrapper'>
                            <label class='table-label '><span>Economies d’électricité</span><span>sur 25 ans*</span> </label>
                          </div>
                        </th>
                        <td class=''>
                          <label className="table-label">
                          {minimumSimulation ? (Math.floor(minimumSimulation.savings25Years).toLocaleString('fr-FR')) : 0} € </label>
                        </td>
                        <td class=''>
                        <label className="table-label">
                        {recommendedSimulation ? (Math.floor(recommendedSimulation.savings25Years).toLocaleString('fr-FR')) : 0} € </label>
                        </td>
                      </tr>
                      <tr className='d-none'></tr>
                      <tr className='d-auto-none'><td colSpan={2}>                <div class='text-wrapper'>
                        <label class='table-label '><span>Votre investissement</span><span>amorti dès *</span></label>
                      </div></td></tr>
                      <tr>
                        <th scope="row" class='t-non-background'>
                          <div class='text-wrapper'>
                            <label class='table-label '><span>Votre investissement</span><span>amorti dès *</span></label>
                          </div>
                        </th>
                        <td class=''>
                        <label className="table-label">
                        {minimumSimulation ? minimumSimulation.amortizationTime : 0} ans
                        </label></td>
                        <td class=''>
                        <label className="table-label">
                        {recommendedSimulation ? recommendedSimulation.amortizationTime : 0} ans
                        </label></td>
                      </tr>
                      <tr className='d-none'></tr>
                      <tr className='d-auto-none'><td colSpan={2}>
                        <div class='text-wrapper'>
                          <label class='table-label '><span>Mensualité si achat financé</span></label>
                          <p class='m-0 small-txt '> <i>(* Financement sur 15 ans TAEG 6.15 % )</i></p>
                        </div></td></tr>
                      <tr>
                        <th scope="row" class='t-non-background'>
                          <div class='text-wrapper'>
                            <label class='table-label '><span>Mensualité si achat financé</span></label>
                            <p class='m-0 small-txt ' style={{ fontWeight: 500 }}> <i>(* Financement sur 15 ans TAEG 6.15 % )</i></p>
                          </div>
                        </th>

                        <td class=''>
                        <label className="table-label">
                      {minimumSimulation ? (Math.floor(minimumSimulation.monthlyPayment).toLocaleString('fr-FR')) : 0} € / mois
                        
                        </label>

</td>
                        <td class=''>
                        <label className="table-label">
                      {recommendedSimulation ? (Math.floor(recommendedSimulation.monthlyPayment).toLocaleString('fr-FR')) : 0} € / mois
                        
                        </label>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row" class='t-non-background'>
                          <div class='text-wrapper'>

                          </div>
                        </th>
                        <td colSpan={2} class='text-center t-non-background'>              <Button
                          variant="flat"
                          onClick={() => handleNext(4)}
                          className={`text-light w-100`}
                        >
                           J’affine mon choix avec un conseiller
                        </Button></td>
                      </tr>
                      <tr className='last-row'>
                        <th scope="row" class='t-non-background'>
                          <div class='text-wrapper'>

                          </div>
                        </th>
                        <td colSpan={2} class='text-center '>
                          <div class='d-flex align-items-center justify-content-end w-100'>
                            <p class='m-0 small-txt est-text'>* Estimation faite sur la base d’hypothèses de calculs </p>
                            <button class='question-btn' onClick={handleModal}>
                              <img src={questionsvg} />
                            </button>
                            {/* <img src={require('../assets/image/question.svg')} /> */}
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
</div>

              </>
            )
          }

         {
            step === 3 && !this.state.secondLoader && this.state.oneColumnTrigger && (
              <>
            
              <div class='table-wrapper d-flex align-items-center justify-content-end'>
    <table class="custom-table-column-one">
        <thead>
            <tr class='t-head'>
                <th class="t-non-background"></th>
                <td class="t-head-item bg-danger"><label class='table-label'><span>Notre</span>
                meilleure  offre</label>
                </td>
            </tr>
        </thead>
        <tbody>
            <tr>
                <th scope="row" class='t-non-background'>
                    <div class='text-wrapper'>
                        <label class='table-label'>Prix d’achat TTC </label>
                        <p class='m-0 small-txt' style={{fontWeight: 500}}>(aide déduite*)</p>
                    </div>
                </th>
               
                <td class=' px-3'>
                    
                    <div class='main-wrapper'> <label class='table-label text-danger big-label'>à partir de {minimumSimulation?(Math.floor(minimumSimulation.netPrice).toLocaleString('fr-FR')):0} €</label> <p class='small-txt m-0'>(Aide de {minimumSimulation?(minimumSimulation.subsidy.toLocaleString('fr-FR')):0} € déduite*)</p></div>
                </td>
                {/* <td class=' px-3'>
                    <div class='main-wrapper'> <label class='table-label text-danger big-label'>à partir de {recommendedSimulation?(Math.floor(recommendedSimulation.netPrice).toLocaleString('fr-FR')):0} €</label> <p class='small-txt m-0'>(Aide de {recommendedSimulation?(recommendedSimulation.subsidy.toLocaleString('fr-FR')):0} €)</p></div>
                </td> */}
            </tr>
            <tr>
                <th scope="row" class='t-non-background'>
                    <div class='text-wrapper'>
                        <label class='table-label '><span>Puissance</span><span>
                            Nombre de panneaux</span>
                        </label>
                    </div>
                </th>
                <td class=' px-3'>
            
                    
                    <div class='main-wrapper'> 
                        <label class='table-label big-label'><span>{minimumSimulation?(minimumSimulation.recommandedPower):0} KWc</span><span>{minimumSimulation?minimumSimulation.recommandedNbrPannels:0} panneaux</span></label>
                    </div>
                </td>
            </tr>
            <tr>
                <th scope="row" class='t-non-background'>
                    <div class='text-wrapper'>
                        <label class='table-label '><span>Economies  d’électricité</span><span>
                            dès la 1ere année*</span>
                        </label>
                    </div>
                </th>
                <td class=' px-3'>
                    <div class='main-wrapper'> <label class='table-label text-danger big-label'>{minimumSimulation?(minimumSimulation.savingsFirstYear.toLocaleString('fr-FR')):0} €</label><p class='small-txt text-danger m-0'>(- {minimumSimulation?minimumSimulation.savingsPercent:0} % sur la facture)</p></div>
                </td>
            </tr>
            <tr>
                <th scope="row" class='t-non-background'>
                    <div class='text-wrapper'>
                        <label class='table-label '><span>Economies d’électricité</span><span>sur 25 ans*</span> </label>
                    </div>
                </th>
                <td class=''>
                  {minimumSimulation?(Math.floor(minimumSimulation.savings25Years).toLocaleString('fr-FR')):0} €
                </td>
            </tr>
            <tr>
                <th scope="row" class='t-non-background'>
                    <div class='text-wrapper'>
                        <label class='table-label '><span>Votre investissement</span><span>amorti dès *</span></label>
                    </div>
                </th>
                <td class=''>
                  {minimumSimulation?minimumSimulation.amortizationTime:0} ans</td>


            </tr>
            <tr>
                <th scope="row" class='t-non-background'>
                    <div class='text-wrapper'>
                        <label class='table-label '><span>Mensualité</span><span>si achat financé</span></label>
                        <p class='m-0 small-txt ' style={{fontWeight: 500}}> <i>(* Financement sur 15 ans TAEG 6.15 % )</i></p>
                    </div>
                </th>

                <td class=''>
                  {minimumSimulation?(Math.floor(minimumSimulation.monthlyPayment).toLocaleString('fr-FR')):0} € / mois</td>
            </tr>
            <tr>
                <th scope="row" class='t-non-background'>
                    <div class='text-wrapper'>

                    </div>
                </th>
                <td colSpan={1} class='text-center t-non-background'>              <Button
                    variant="flat"
                    onClick={handleNext}
                    className={`text-light w-100`}
                >
                    J’affine mon choix avec un conseiller
                </Button></td>
            </tr>
            <tr className='last-row'>
                <th scope="row" class='t-non-background'>
                    <div class='text-wrapper'>

                    </div>
                </th>
                <td colSpan={1} class='text-center '>
                    <div class='d-flex align-items-center justify-content-end w-100'>
                        <p class='m-0 small-txt'>* Estimation faite sur la base d’hypothèses de calculs </p>
                        <button class='question-btn' onClick={handleModal}>
                            <img src={questionsvg} /></button>
                        {/* <img src={require('../assets/image/question.svg')} /> */}
                    </div>
                </td>
            </tr>
        </tbody>
    </table>
</div>

              </>
            )
          }
          

          {
            step === 4 && !this.state.secondLoader && (

              <div className="contacte-form">
                <label className='label-class w-100 mx-auto mb-3 label-col'>
                  <span className='big-title'>{`Personnalisez votre projet avec notre équipe`}</span>
                  <span>{`Nous sommes impatients d’échanger avec vous sur votre projet solaire`}</span>
                </label>

                <div className='two-col-row' style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <div className="two-col">
                    <label htmlFor="nom" className='label-class'>Nom*</label>
                    <input
                      type="text"
                      className="form-control"
                      id="nom"
                      name="nom"
                      placeholder='nom'
                      value={this.state.nameLead}
                      onChange={(e) => this.setState({ nameLead: e.target.value })}
                    // onChange={(e) => {
                    //   const selectedValue = e.target.value;
                    //   this.setState({nameLead:selectedValue})
                    // }}
                    //  onChange={this.handleChange}
                    />
                  </div>
                  <div className="two-col">
                    <label htmlFor="prenom" className='label-class'>Prénom*</label>
                    <input
                      type="text"
                      className="form-control"
                      id="prenom"
                      name="prenom"
                      placeholder='prenom'
                      value={this.state.surnameLead}
                      onChange={(e) => {
                        const selectedValue = e.target.value;
                        this.setState({ surnameLead: selectedValue })
                      }}
                    />
                  </div>
                </div>

                <div className='two-col-row' style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <div className="two-col">
                    <label htmlFor="email" className='label-class'>Email*</label>
                    <input
                      type="email"
                      className="form-control no-shadow"
                      id="email"
                      name="email"
                      placeholder='abc@gmail.com'
                      value={this.state.email}
                      onChange={this.handleChange}
                      />
                      {this.state.emailError && <div className='d-flex align-items-center justify-content-start'><p style={{ float: "left" }} className='text-danger m-0'><span className='text-danger m-0' style={{ fontWeight: "bold", fontSize: "25px" }}>&#8594;</span> eMail invalide</p></div> }
                  </div>
                  <div className="two-col">
                    <label htmlFor="telephone" className='label-class'>Téléphone* </label>
                    <input
                      type="number"
                      className="form-control no-shadow"
                      id="telephone"
                      
                      name="telephone"
                      placeholder='06 18 65 65 89'
                      value={this.state.phone}
                      onChange={(e) => {
                        const selectedValue = e.target.value;
                        this.setState({ phone: selectedValue })
                      }}
                    />
              {((this.state.phone.length !== 10 && this.state.phone.length > 0) || (this.state.phone.length > 0 && this.state.phone[0] !== '0')) && <div className='d-flex align-items-center justify-content-start'><p style={{ float: "left" }} className='text-danger m-0'><span className='text-danger m-0' style={{ fontWeight: "bold", fontSize: "25px" }}>&#8594;</span> numéro de téléphone invalide</p></div> }
                  </div>
                </div>

                <div className="one-col">
                  <label htmlFor="echeance" className='label-class'>Code de parrainage
                  </label>
                  <div className='droup-select'>
                    
                  <input
                      type="number"
                      className="form-control no-shadow"
                      id="telephone2" 
                      name="telephone2"
                      placeholder='0123456789'
                      value={this.state.projectTiming}
                      onChange={(e) => {
                        const selectedValue = e.target.value;
                        this.setState({ projectTiming: selectedValue })
                      }}
                    />
                   
                  </div>
                </div>
                

                {/* <div class="mt-5">
                  <div style={{display:'flex'}}>  <input type="checkbox" style={{ marginRight: '5px' ,width:'20px'}} />
                    <div>
                        J’accepte que mes données soient transmises pour faire une étude détaillée de mon projet et finaliser mon éligibilité
                    </div>
                  </div>
              </div> */}
              <div className='info'>* : informations obligatoires à nous transmettre</div>
                <div class="checkbox-sec">
                  <div className='checkbox-inr'>
                    <input
                      type="checkbox"
                      checked={isChecked}
                      className='custom-checkbox'
                      onChange={this.handleCheckboxChange}
                    />
                    <label>
                    En cliquant sur « Je valide », j'indique accepter les <a href="https://www.conforama.fr/conditions-generales-utilisation-site-conforama">Conditions Générales de Vente</a> ("CGV") et donne mon accord pour le traitement de mes données. Je comprends que les informations marquées par un astérisque sont obligatoires afin de pouvoir traiter ma demande. Elles sont à destination exclusivement de Conforama. Pour plus d’informations sur nos traitements de vos données et sur vos droits à cet égard, merci de consulter notre <a href='https://www.conforama.fr/politique-donnees-personnelles'>Politique de confidentialité</a>
                    </label>
                  </div>
                </div>


                <div class="checkbox-sec">
                  <div className='checkbox-inr'>
                  <input
                    type="checkbox"
                    className='custom-checkbox'
                    checked={isChecked1}
                    onChange={this.handleCheckboxChange1}
                  />
                   <label>J’accepte de recevoir des newletters m’informant sur les évolutions des offres Conforama par voie électronique. Mes données personnelles d'identification et de contact seront traitées dans le cadre de la politique de protection des données disponibles <a href='https://www.conforama.fr/politique-donnees-personnelles'>ici</a>
                    </label>
                </div>
                </div>
                <div className='w-100 btn-right'>
                <Button
                  onClick={handleFormSubmit}
                  disabled={isFormInvalid  || this.state.isFormSubmit}
                  className={`text-light`}
                  variant={isFormInvalid?"secondary":"flat"}
                >
                   Je valide
                </Button>
                </div>
                </div>







            )
          }

          {
            this.state.showModal && (
              <>
              <Modal show={this.state.showModal} onHide={this.handleClose} size='xl' >
                
                  <Modal.Body className='question-modal'>
                    <div className='que-header' onClick={this.handleClose} >
                      <div className='close-icon' style={{ cursor: 'pointer' }}><i className="fas fa-close text-light "></i></div></div>
                    <div>
                   
                      <div className='content-wrapper'>
                        <h3>Nos estimations d'économie sont indicatives et non contractuelles </h3>
                        <p>Le calcul des économies est la différence entre le montant de la facture d’électricité (scénario sans passer au solaire) subissant les augmentations du prix marché pour une consommation en kWh constante, et le montant de la facture d'électricité avec les économies réalisées avec le solaire (autoconsommation + revente de surplus).</p>
                        <p>
                        Les économies sur 25 ans incluent la prime à l’autoconsommation mais ne tiennent pas compte du montant d'achat de la centrale solaire. 
                        </p>
                        <p>Les hypothèses suivantes sont prises :</p>
                        <ul className='qm-list'>
                          <li>Famille de 4 personnes (2 adultes + 2 enfants)</li>
                          <li>Présence en semaine : Télétravail 2 jours</li>
                          <li>Équipements énergivores :
                            <ul>
                              <li>Chauffage de l’eau chaude sanitaire (fonctionnant en heure creuse) : Ballon électrique de 200 L</li>
                              <li>Chauffage et climatisation avec une pompe à chaleur air-eau</li>
                              <li>Pas de piscine, spa ou sauna</li>
                              <li>Pas de borne de recharge pour véhicule électrique</li>
                              <li>Si inclinaison non détectée automatiquement, par défaut 20°</li>
                            </ul>
                          </li>
                          <li>Augmentation du prix de l’électricité : 5% par an pendant les 10 prochaines années, puis 3% pendant les années suivantes</li>
                          <li>Perte de productivité des panneaux de 0,5% par an</li>
                        </ul>
                        <p>Le montant de la Prime à l’autoconsommation et le prix de rachat des kWh réinjectés dans le réseau dépendent de la date de demande complète de raccordement auprès du gestionnaire de réseau Enedis ou ELD. Les valeurs prises en compte sont celles communiquées par la CRE au jour de la simulation.</p>
                        <p>Concernant la mensualité de financement : prêt affecté avec un TAEG de 6,15% et un taux d’assurance de 2,74%.</p>
                        <p>Les calculs sont établis en fonction des renseignements fournis lors de la simulation, et dépendent notamment des conditions d’ensoleillement réel et des choix et pratiques quotidiennes d’utilisation des équipements électriques dans le foyer. Une visite technique sera probablement nécessaire pour confirmer la faisabilité technique du projet et les projections d’économies.</p>
                      </div>
                    </div>
                  </Modal.Body>
 
      </Modal></>
            )
          }


        </div>
      </div>
    );
  }
}

export default Autocomplete;
